import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Calculator } from '@ratehub/base-ui';
import CALCULATOR_WIDTHS from '../definitions/CalculatorWidths';
import ContributionLimitTFSACalcInputStep from './ContributionLimitTFSACalcInputStep';


function ContributionLimitTFSACalculator({ ...otherProps }) {

    return (
        <StyledCalculator
            title={(
                <FormattedMessage
                    id="mtg-calculator.ContributionLimitTFSACalculator.calculatorTitle"
                    defaultMessage="Ratehub.ca's TFSA contribution room calculator"
                />
            )}
            {...otherProps}
        >
            <ContributionLimitTFSACalcInputStep
                {...otherProps}
            />

        </StyledCalculator>
    );
}

const StyledCalculator = styled(Calculator)`
    max-width: ${CALCULATOR_WIDTHS.SMALL};
`;

export default observer(ContributionLimitTFSACalculator);